import { createTranslations } from '@npco/utils-translations'

export const spendManagementControlReviewTranslations = createTranslations({
  title: 'Spend Management Controls',
  spendLimitLabel: 'Spend Limit',
  spendLimitFrequencyLabel: 'Spend Limit Frequency',
  maxTransactionLimitLabel: 'Max Transaction Limit',
})
